module.exports = __webpack_public_path__ + "img/why-ai-agents-break-in-production.ad932616.webp";